/**
 * @generated SignedSource<<9af9a4bddc5b61888b6a7775fe1bf0b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TransferReportOwnershipInput = {
  reportId?: string | null;
  newOwnerId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type TransferReportOwnershipMutation$variables = {
  input: TransferReportOwnershipInput;
};
export type TransferReportOwnershipMutation$data = {
  readonly transferReportOwnership: {
    readonly savedReport: {
      readonly person: {
        readonly id: string;
        readonly active: boolean | null;
        readonly email: string | null;
        readonly fullName: string | null;
        readonly profilePictureId: string | null;
      } | null;
    } | null;
  } | null;
};
export type TransferReportOwnershipMutation = {
  variables: TransferReportOwnershipMutation$variables;
  response: TransferReportOwnershipMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransferReportOwnershipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransferReportOwnershipPayload",
        "kind": "LinkedField",
        "name": "transferReportOwnership",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SavedReportType",
            "kind": "LinkedField",
            "name": "savedReport",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransferReportOwnershipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransferReportOwnershipPayload",
        "kind": "LinkedField",
        "name": "transferReportOwnership",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SavedReportType",
            "kind": "LinkedField",
            "name": "savedReport",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dd985397f4f04761c97b7263955e0a79",
    "id": null,
    "metadata": {},
    "name": "TransferReportOwnershipMutation",
    "operationKind": "mutation",
    "text": "mutation TransferReportOwnershipMutation(\n  $input: TransferReportOwnershipInput!\n) {\n  transferReportOwnership(input: $input) {\n    savedReport {\n      person {\n        id\n        active\n        email\n        fullName\n        profilePictureId\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "86f05c55f90fbda732f2a07c5d558d1c";

export default node;
